
import { Component, Vue } from "vue-property-decorator";
import SurveyQuestionsComponent from "@/views/sidebar/survey/survey.vue";
import EmojiKeyComponent from "@/views/sidebar/emoji-key/emoji-key.vue";
import SendNotificationComponent from "@/views/sidebar/notification/notification.vue";
import ParticipantComponent from "@/views/sidebar/participant/participant.vue";
import ResearchDataComponent from "@/views/sidebar/research-data/research-data.vue";
import WatchStatisticsComponent from "@/views/sidebar/watch-statistics/watch-statistics.vue";
import CommercialParticipantComponent from "@/views/sidebar/commercial-participant/participant.vue";
// Import additional sidebar components here as needed.

@Component({
  components: {
    SurveyQuestionsComponent,
    EmojiKeyComponent,
    SendNotificationComponent,
    ParticipantComponent,
    ResearchDataComponent,
    WatchStatisticsComponent,
    CommercialParticipantComponent
    // Register additional sidebar components here.
  },
})
export default class SidebarContainer extends Vue {
}
